export function usePostFilterForm() {
  function PostsListForm(form) {
    if (!(form instanceof Element)) {
      return;
    }

    // Auto submit when checkbox is changed

    const checkboxGroups = form.querySelectorAll(".posts-filter__tax-group");

    checkboxGroups.forEach((cbg) => {
      const checkboxes = cbg.querySelectorAll('[type="checkbox"]');

      function submitForm() {
        console.log("time to submit!");
        form.submit();
      }

      checkboxes.forEach((cb) => {
        cb.addEventListener("change", submitForm);
      });
    });

    // Add clear support for key terms
    const termsGroups = form.querySelectorAll(".posts-filter__terms");

    termsGroups.forEach((tg) => {
      const clearButton = tg.querySelector(".btn--clear");
      const input = tg.querySelector("input");

      function clearInput() {
        input.value = "";
      }

      clearButton.addEventListener("click", clearInput);
    });
  }

  const postFilterForm = document.querySelector(".posts-filter__form");

  postFilterForm && PostsListForm(postFilterForm);
}
